<p-dialog header="Add New Address Type" [modal]="true" [(visible)]="currentDisplayValue" [style]="{width: '45vw'}">
  <form (ngSubmit)="saveAddrType()" #addAdddressTypeFrm="ngForm">
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12">
          <label>Type Name <span style="color: red;">*</span></label>
          <input
            type="text"
            required
            pInputText
            style="width: 100%;"
            name="addressType"
            [(ngModel)]="tempAddrType.name">
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button pButton (click)="cancelAddressType()" label="Cancel" class="p-button-secondary"></button>
    <button pButton label="Save" [disabled]="addAdddressTypeFrm.form.invalid" (click)="addAdddressTypeFrm.ngSubmit.emit()" ></button>
  </p-footer>


</p-dialog>

